import CONFIG from "config/apiConfig";
import Api from "./api";
import DownloadApi from "./downloadApi";

const { API_BASE_URL, API_VERSION } = CONFIG;
const baseURL = `${API_BASE_URL}${API_VERSION}`;

export { Api, DownloadApi, baseURL };
